import { takeLatest, put, call, all, fork } from 'redux-saga/effects';
import OrganisationTypes from './organisation.types';
import {
	createOrganisation,
	updateOrganisation,
	getOrganisation,
	getAllOrganisations,
	updateOrganisationStatus,
} from './organisation.services';
import {
	createOrganisationSuccess,
	createOrganisationFailure,
	updateOrganisationSuccess,
	updateOrganisationFailure,
	getOrganisationSuccess,
	getOrganisationFailure,
	getAllOrganisationsSuccess,
	getAllOrganisationsFailure,
	updateOrganisationStatusSuccess,
	updateOrganisationStatusFailure,
} from './organisation.action';
import AlertManager from '../../utils/alertManager';
import { encryptData } from '../_common/enode-decode';

// Create Organisation Saga
export function* createOrganisationSaga(payload: any) {
	try {
		const key = 'createOrganisationKey';
		const encryptedData = encryptData(payload.payload, key);
		// @ts-ignore
		const responseData = yield call(createOrganisation as any, encryptedData);
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else {
			if (responseData.data.status === 'success') {
				yield put(createOrganisationSuccess(responseData.data));
			} else {
				yield put(createOrganisationFailure(responseData.data));
			}
		}
	} catch (error: any) {
		yield put(createOrganisationFailure(error?.response?.data?.message || 'An error occurred'));
	}
}

// Update Organisation Saga
export function* updateOrganisationSaga(payload: any) {
	try {
		const key = 'updateOrganisationKey';
		const encryptedData = encryptData(payload.payload, key);
		// @ts-ignore
		const responseData = yield call(updateOrganisation as any, encryptedData);
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else {
			if (responseData.data.status === 'success') {
				yield put(updateOrganisationSuccess(responseData.data));
			} else {
				yield put(updateOrganisationFailure(responseData.data));
			}
		}
	} catch (error: any) {
		yield put(updateOrganisationFailure(error?.response?.data?.message || 'An error occurred'));
	}
}

// Get Organisation Saga
export function* getOrganisationSaga(payload: any) {
	try {
		const key = 'getOrganisationKey';
		const encryptedData = encryptData(payload.payload, key);
		// @ts-ignore
		const responseData = yield call(getOrganisation as any, encryptedData);
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else {
			if (responseData.data.status === 'success') {
				yield put(getOrganisationSuccess(responseData.data));
			} else {
				yield put(getOrganisationFailure(responseData.data));
			}
		}
	} catch (error: any) {
		yield put(getOrganisationFailure(error?.response?.data?.message || 'An error occurred'));
	}
}

// Get All Organisations Saga
export function* getAllOrganisationsSaga(data: any) {
	try {
		const key = 'getAllOrganisationsKey';
		const encryptedData = encryptData(data, key);
		// @ts-ignore
		const responseData = yield call(getAllOrganisations as any, encryptedData);
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else {
			if (responseData.data.status === 'success') {
				yield put(getAllOrganisationsSuccess(responseData.data));
			} else {
				yield put(getAllOrganisationsFailure(responseData.data));
			}
		}
	} catch (error: any) {
		yield put(
			getAllOrganisationsFailure(error?.response?.data?.message || 'An error occurred'),
		);
	}
}

// Update Organisation Status Saga
export function* updateOrganisationStatusSaga(payload: any) {
	try {
		const key = 'updateOrganisationStatusKey';
		const encryptedData = encryptData(payload.payload, key);

		// @ts-ignore
		const responseData = yield call(updateOrganisationStatus as any, encryptedData);
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else {
			if (responseData.data.status === 'success') {
				yield put(updateOrganisationStatusSuccess(responseData.data));
			} else {
				yield put(updateOrganisationStatusFailure(responseData.data));
			}
		}
	} catch (error: any) {
		yield put(
			updateOrganisationStatusFailure(error?.response?.data?.message || 'An error occurred'),
		);
	}
}

// Watcher Sagas
export function* onCreateOrganisationStart(): Generator<any, void, any> {
	yield takeLatest(OrganisationTypes.CREATE_ORGANISATION_START as any, createOrganisationSaga);
}

export function* onUpdateOrganisationStart(): Generator<any, void, any> {
	yield takeLatest(OrganisationTypes.UPDATE_ORGANISATION_START as any, updateOrganisationSaga);
}

export function* onGetOrganisationStart(): Generator<any, void, any> {
	yield takeLatest(OrganisationTypes.GET_ORGANISATION_START as any, getOrganisationSaga);
}

export function* onGetAllOrganisationsStart(): Generator<any, void, any> {
	yield takeLatest(OrganisationTypes.GET_ALL_ORGANISATIONS_START as any, getAllOrganisationsSaga);
}

export function* onUpdateOrganisationStatusStart(): Generator<any, void, any> {
	yield takeLatest(
		OrganisationTypes.UPDATE_ORGANISATION_STATUS_START as any,
		updateOrganisationStatusSaga,
	);
}

// Main Saga
export function* organisationSagaDetails(): Generator<any, void, any> {
	yield all([
		fork(onCreateOrganisationStart),
		fork(onUpdateOrganisationStart),
		fork(onGetOrganisationStart),
		fork(onGetAllOrganisationsStart),
		fork(onUpdateOrganisationStatusStart),
	]);
}
